import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthWrapper } from '@weareopenr/authkit';

import { PrimaryButton, Typography } from '@weareopenr/component-library';
import openrLogo from '../../assets/images/openr-logo.svg';
import styles from './Welcome.module.scss';

const Welcome = () => {
  const { user, signIn } = useAuthWrapper();

  useEffect(() => {
    document.title = 'Welcome';
  }, []);

  const login = async () => {
    await signIn();
  };

  if (user) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <img src={openrLogo} alt="Openr" className={styles.logo} />
        <Typography size="xlarge" weight="bold" className={styles.title}>
          Welcome Back
        </Typography>
        <PrimaryButton size="full-width" onClick={login}>
          Log in
        </PrimaryButton>
      </div>
    </div>
  );
};

export default Welcome;
